<template>
  <div class="content-source-item">
    <div v-show="deleting" class="deleting-source-spinner">
      <i class="fa-light fa-circle-notch fa-spin"></i>
    </div>
    <form
      class="form-wrapper"
      @submit.stop.prevent="saveSource()"
      :class="{ 'deleting-source': deleting }"
      ref="sourceitem"
    >
      <DynamicForm
        class="dynamic-form"
        :formData="formData"
        :source="contentSource.config"
        :formDataIndex="formDataIndex"
        @changes="changesMade"
        @submit-event="saveSource"
        @search-example-id="searchExampleId"
        @invalid-fields="validateFields"
      />
      <div class="actions">
        <div :tooltip="invalidForm ? invalidFormMsg : ''" tooltip-placement="right">
          <SaveButton
            data-cy="save-connector-btn"
            :buttonText="$t('save')"
            :disabled="!changes || invalidForm"
            :onSave="() => saveSource()"
            :loading="saving"
            :saved="saveComplete"
            :saveErr="saveIncomplete"
            @saveCompleteHandled="saveComplete = false"
            @saveErrHandled="saveIncomplete = false"
          />
        </div>
        <button class="btn btn-secondary" type="button" @click="onDeleteSource">
          {{ $t("delete") }}
        </button>
        <div
          class="connection-check"
          v-switch="connectionStatus"
          slot="icon"
          :tooltip="connectionStatus == '' ? $t('connection.checking') + '...' : connectionStatusMsg"
          tooltip-placement="right"
        >
          <span v-case="''"> <i class="fa-light fa-circle-notch fa-spin"></i> <span class="text-xs"></span> </span>
          <span v-case="'Ok'">
            <i class="fa-light fa-circle-check text-success"></i>
          </span>
          <span v-default>
            <i class="fa-light fa-circle-exclamation text-danger"></i>
            <!-- <span class="text-xs">{{connectionStatus}}</span> -->
          </span>
        </div>
        <div v-if="invalidForm || connectionStatus !== 'Ok'" class="text-xs help-text">
          <a href="https://help.icrobotics.com/integrations" target="_blank">{{$t('connection.help')}}</a>
        </div>
      </div>
      <span class="text-small text-danger" v-if="error">{{ $t("standard-error") }}</span>
    </form>
  </div>
</template>

<script>
import ExampleIdSearch from "@/components/modals/ExampleIdSearch";
import DynamicForm from "@/components/DynamicForm";
import SaveButton from "@/components/SaveButton";
import { vSwitch, vCase, vDefault } from "v-switch-case";
export default {
  directives: {
    switch: vSwitch,
    case: vCase,
    default: vDefault
  },
  name: "ConnectorContentSource",
  props: {
    formData: Array,
    formDataIndex: Number,
    contentSource: Object,
    connectionStatus: String
  },
  data() {
    return {
      changes: false,
      saving: false,
      error: false,
      saveComplete: false,
      saveIncomplete: false,
      invalidForm: false,
      invalidFormMsg: "",
      deleting: false
    };
  },
  computed: {
    connectionStatusMsg() {
      return this.connectionStatus == "Ok" ? this.$t("connection.ok") : this.connectionStatus;
    }
  },
  methods: {
    changesMade() {
      this.changes = true;
    },

    saveSource() {
      this.error = false;
      this.saving = true;
      this.changes = false;
      this.$store
        .dispatch("editFixedIntegration", this.contentSource)
        .then((res) => {
          this.saving = false;
          this.$emit("check-connection", [this.contentSource.id]);
          this.saveComplete = true;

          if (this.$store.state.postDemoGuide) {
            this.$store.commit("setDemoGuideCurrentStep", 3);
            this.$store.commit("showDemoGuide", true);
          }
        })
        .catch((e) => {
          this.saveIncomplete = true;
          this.saving = false;
          this.error = true;
          this.changes = true;
        });
    },

    onDeleteSource() {
      this.$store
        .dispatch("showConfirmation", {
          title: this.$t("delete-modal.delete"),
          description: this.$t("delete-modal.delete-integration-desc") + this.contentSource.name,
          confirmButtonText: this.$t("delete-modal.accept")
        })
        .then(() => {
          this.deleteSource();
        });
    },

    deleteSource() {
      this.deleting = true;
      this.$store
        .dispatch("deleteFixedIntegration", this.contentSource)
        .then((lastFixed) => {
          if (lastFixed) this.$emit("update-selected", null);
        })
        .catch((e) => {
          this.deleting = false;
        });
    },

    searchExampleId() {
      this.$modal.show(
        ExampleIdSearch,
        {
          contentSource: this.contentSource,
          selectAsExampleId: (id) => {
            this.$set(this.contentSource.config, "exampleId", id);
            this.changesMade();
          }
        },
        { width: 310, height: "auto" }
      );
    },

    validateFields(data) {
      this.invalidForm = data.invalidForm;
      this.invalidFormMsg = data.invalidFormMsg;
    }
  },
  mounted() {
    if (this.$store.state.postDemoGuide) {
      const demoPopupPlacement = this.$refs.sourceitem.getBoundingClientRect();
      this.$store.commit("addPositionToDemoGuide", {
        step: 2,
        x: demoPopupPlacement.left,
        y: demoPopupPlacement.y,
        placement: "left"
      });
      this.$store.commit("setDemoGuideCurrentStep", 2);
      this.$store.commit("showDemoGuide", true);
    }
  },
  components: {
    DynamicForm,
    SaveButton
  }
};
</script>

<style lang="less">
.content-source-item {
  position: relative;
  margin-top: 20px;
  .form-wrapper {
    background-color: var(--background-white);
    padding: 20px;
    border-radius: var(--standard-border-radius);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);

    .dynamic-form {
      display: grid;
      gap: 0 20px;
      grid-template-columns: repeat(2, 1fr);

      .radio-btns-dynamic {
        padding: 0 0 12px 0;
      }

      .form-item {
        display: block;
        &.form-group {
          // margin: 0 !important;
        }
      }
    }
    .actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 1rem;
      button {
        margin-right: 10px;
      }

      .help-text {
        position: absolute;
        right: 20px;
        
      }
    }

    @media only screen and (max-width: 880px) {
      .dynamic-form {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
}
</style>
